/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Table as MantineTable, type MantineTheme, createTheme } from '@mantine/core';

import { colorToken } from '@fai/design-tokens';

import * as classes from './table.css';

export const tableTheme = createTheme({
  components: {
    Table: MantineTable.extend({
      vars: (_, props) => ({
        table: {
          '--table-border-color': colorToken.color.border.neutral.default,
        },
      }),
      classNames: (_, props) => ({
        table: classes.table,
        thead: classes.thead,
        tr: classes.tr,
        th: classes.th,
        td: classes.td,
      }),
    }),
  },
}) as MantineTheme;
